import React from "react";
import { useAlert } from "hooks/useAlert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import "./alert.scss";

export const Alert = () => {
    const { messages, closeAlert } = useAlert();

    return (
        <div className="alerts">
            {messages.map(({ id, type, message, isClosable }) => {
                return (
                    <div key={id} className={`notification-container -${type}`}>
                        <div className="notification-message">{message}</div>
                        <div className="notification-close-button">
                            {isClosable && (
                                <button className="button -text" onClick={() => closeAlert(id)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
